import { fromSpecific, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { AnyExpressionSpecific, MustacheNode } from '../Mustache'
import type { TypedSpecificLike } from '@rehaje/core'

export interface CSSStyleSheetSpecific extends TypedSpecificLike {
  rules?: AnyExpressionSpecific | string
  type: 'CSSStyleSheet'
}

export class CSSStyleSheetNode extends TypedNode {
  @fromSpecific()
  @reactive()
  rules: MustacheNode | string = ''
}

declare global {
  export interface RehajeSpecifics {
    CSSStyleSheet: CSSStyleSheetSpecific
  }
  export interface RehajeTypedNodes {
    CSSStyleSheet: CSSStyleSheetNode
  }
}
